<template>
  <div class="bg">
    <!-- banner   -->
    <div class="banner">
      <div class="content-1200 H100 flex-column flex-centent">
        <div class="title fontWeight-800 fontSize48">加入我们</div>
        <div class="desc fontSize16 color-level4">
          移动智能终端生态联盟是国内领先的行业非盈利性组织，由领先的智能终端厂商联合发起和建立，旨在推动全行业应用生态标准化、规范化、合规化、高效化，提升全行业应用服务水平和能力，促进行业共赢、共发展。
        </div>
        <!--        <more-button text="现在加入" @handleClick="handlerPartner"></more-button>-->
      </div>
    </div>
    <reveal-animation>
      <!-- 我们在寻找这样的伙伴   -->
      <div class="box content-1200">
        <div class="main-title fontWeight-800 fontSize36 color-level1 text-center">我们在寻找这样的伙伴</div>
        <div class="partner flex-nowrap space-between">
          <div class="cursor" v-for="(item,index) in partnerList" :key="index" @click="item.clickEvent">
            <div class="title font-blod fontSize20 white">
              <span>{{ item.title }}</span>
              <span class="tag">
                <span class="tag-content">{{ item.tag }}</span>
              </span>
            </div>
            <div class="desc fontWeight-500 color-level4 flex-column margin-b60">
              <span v-for="(desc,indey) in item.desc" :key="indey">{{ desc }}</span>
            </div>
            <div class="btn flex-start">
              <img src="~@/assets/img/join/jump-icon.png" alt="">
              <span class="color-main1 cursor">{{ item.btnText }}</span>
            </div>
          </div>
        </div>
      </div>
    </reveal-animation>
    <reveal-animation>
      <!-- 我们的能力，让合作共赢真实可靠   -->
      <div class="box content-1200">
        <div class="main-title fontWeight-800 fontSize36 color-level1 text-center">我们的能力，让合作共赢真实可靠</div>
        <div class="advantage flex-nowrap space-between">
          <div v-for="(item,index) in advantageList" :key="index">
            <img class="margin-b80" :src="item.pic" alt="">
            <div class="margin-b20 font-blod fontSize20 white">{{ item.title }}</div>
            <div class="desc fontWeight-500 color-level4">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </reveal-animation>
    <reveal-animation>
      <!-- 您将获得这些   -->
      <div class="box content-1200 obtain-box">
        <div class="main-title fontWeight-800 fontSize36 color-level1 text-center">您将获得这些</div>
        <div class="obtain">
          <div v-for="(item,index) in obtainList" :key="index">
            <div class="fontSize20 font-blod color-level1 flex-start">
              <img class="margin-r8" src="~@/assets/img/join/obtain-check.png" alt="">
              {{ item.title }}
            </div>
            <div class="desc color-level2">{{ item.desc }}</div>
          </div>
        </div>
        <more-button
            class="margin-t40"
            text="更多权益请参阅我们的《章程》"
            @handleClick="$router.push('/home/constitution')"
        ></more-button>
      </div>
    </reveal-animation>

    <!-- 获得金标认证 -->
    <div class="join flex-center">
      <reveal-animation :options="{duration:1000,delay:0}">
        <div class="flex-center flex-column">
          <div class="title fontSize24 margin-b20 font-blod">加入我们，与全行业共享发展机会</div>
          <div class="btn text-center font-blod color-level1 cursor" @click="handlerPartner">立即加入</div>
        </div>
      </reveal-animation>
    </div>

    <!-- 生态单位弹窗   -->
    <unit-dialog ref="unitDialogRef"/>
    <!-- 理事单位弹窗   -->
    <member-dialog ref="memberDialogRef"/>
  </div>
</template>

<script>
import MoreButton from "@/components/common/MoreButton.vue";
import UnitDialog from "./components/UnitDialog.vue";
import MemberDialog from "./components/MemberDialog.vue";
import RevealAnimation from "@/components/common/RevealAnimation";

export default {
  metaInfo: {
    title: "ITGSA | 移动智能终端生态联盟 | 加入我们",
    meta: [
      {
        name: 'keywords',
        content: '金标认证资格，建立行业标准，应用生态优先服务资格，庞大的应用生态，覆盖面极广的用户'
      },
      {
        name: 'description',
        content: '移动智能终端生态联盟是国内领先的行业非盈利性组织，由领先的智能终端厂商联合发起和建立，旨在推动全行业应用生态标准化、规范化、合规化、高效化，提升全行业应用服务水平和能力，促进行业共赢、共发展。'
      },
    ]
  },
  components: {MoreButton, UnitDialog, MemberDialog, RevealAnimation},
  data() {
    return {
      partnerList: [
        {
          title: '生态单位',
          desc: ['参与技术标准制定', '共享联盟服务资源', '推动行业应用生态建设'],
          btnText: '成为生态单位',
          tag: '面向开发者',
          clickEvent: this.handlerPartner
        },
        {
          title: '理事单位成员',
          desc: ['参与讨论联盟的战略方向、重大事项', '参与联盟下设的工作组或项目', '参与联盟技术标准制定'],
          btnText: '成为理事单位成员',
          tag: '面向OEM厂商',
          clickEvent: this.handlerMember
        }
      ],
      advantageList: [
        {
          title: '领先的厂商联合建立',
          desc: '由中国领先的智能终端厂商发起，拥有广泛的影响力。多方面的应用认证权威、可靠，可信。',
          pic: require('@/assets/img/join/advantage1.png')
        },
        {
          title: '庞大的应用生态',
          desc: '覆盖广阔市场的应用生态，囊括市场上大部分的应用和开发者，服务类型多样，服务效果显著。',
          pic: require('@/assets/img/join/advantage2.png')
        },
        {
          title: '覆盖面极广的用户',
          desc: '深受用户喜爱的移动智能终端品牌，能够面向数亿用户提供统一、便捷、高效的服务和产品。',
          pic: require('@/assets/img/join/advantage3.png')
        },
      ],
      obtainList: [
        {
          title: '领先的厂商联合建立',
          desc: '我们的伙伴所生产的应用将有资格在各大应用市场获得标示应用安全、可靠、可信的「金标」，提升用户信任感，提高应用价值。'
        },
        {
          title: '建立行业标准参与资格',
          desc: '我们的伙伴有资格参与到包括兼容性、稳定性、安全与隐私等多种类似的行业统一标准的建立与制定的工作中，推动全行业质量提升，服务水准提高。'
        },
        {
          title: '联盟活动参与资格',
          desc: '在联盟面向开发者、行业、用户等举办的活动中，我们的伙伴均有资格和机会参与其中，获得与行业、用户、开发者交流和讨论的机会。'
        },
        {
          title: '应用生态优先服务资格',
          desc: '我们的应用生态为我们的伙伴提供优先服务资格，包括优先审核、优先认证、优先咨询等服务，满足应用开发方方面面的需求。'
        },
        {
          title: '领先的厂商通用服务',
          desc: '我们领先的测试工具、生产力工具、合规工具等均面向我们的伙伴开放。我们的伙伴能够利用厂商领先的工具和平台提高生产效率。'
        },
        {
          title: '生态成员价值',
          desc: '成为我们的伙伴，将享受到联盟中的各项权利和资 格，并与全行业领先的伙伴们共同交流、协作。'
        },
      ]
    }
  },
  methods: {
    //成为战略生态合作伙伴
    handlerPartner() {
      this.$refs.unitDialogRef.showDialog()
    },
    //成为理事单位成员
    handlerMember() {
      this.$refs.memberDialogRef.showDialog()
    }
  },
};
</script>

<style lang="scss" scoped>
.main-title {
  margin-bottom: 60px;
}

.box {
  padding: 80px 0 40px;
}

.banner {
  width: 100%;
  height: 600px;
  background-image: url("~@/assets/img/join/banner.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  .title {
    margin-bottom: 12px;
    background: linear-gradient(359.9999999898547deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }

  .desc {
    width: 644px;
    margin-bottom: 32px;
    line-height: 27px;
  }

  .more-btn {
    background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    border: 1px solid transparent;
    margin: initial;
    font-weight: 700;
    color: $color-level1;
  }
}

.partner {
  & > div {
    width: 590px;
    height: 320px;
    padding: 60px 0 0 32px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    transition: background-size 0.5s ease;
    overflow: hidden;

    &:hover {
      background-size: 110%;
    }

    &:nth-of-type(1) {
      background-image: url("~@/assets/img/join/partner1.png");
    }

    &:nth-of-type(2) {
      background-image: url("~@/assets/img/join/partner2.png");
    }

    .title {
      margin-bottom: 12px;

      .tag {
        display: inline-block;
        background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
        border-radius: 4px 4px 4px 4px;
        height: 20px;
        line-height: 20px;
        font-weight: 500;
        font-size: 12px;
        color: #000000;
        transform: skewX(-8deg);
        padding: 0 8px;
        margin-left: 8px;
        position: relative;
        bottom: 4px;

        &-content {
          display: inline-block;
          transform: skewX(8deg);
        }
      }
    }

    .desc {
      line-height: 24px;
    }

    .btn img {
      width: 32px;
      height: 32px;
      margin-right: 12px;
    }
  }
}

.advantage {
  & > div {
    width: 387px;
    height: 338px;
    background: #262626;
    border-radius: 8px 8px 8px 8px;
    padding: 40px 32px 60px;
    transition: transform 0.5s ease;

    &:hover {
      transform: translateY(-20px);
    }

    img {
      width: 64px;
      height: 64px;
    }

    .desc {
      line-height: 24px;
    }
  }
}

.obtain-box {
  .obtain {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 40px 50px;

    & > div {
      width: 387px;
      height: 201px;
      border-radius: 8px 8px 8px 8px;
      padding: 40px 32px;
      background-image: url("~@/assets/img/join/obtain-bg.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;


      &:hover {
        box-shadow: 0px 7px 13px 0px #E9E9E9;
        border-radius: 20px 20px 20px 20px;
      }

      .desc {
        margin-top: 23px;
        line-height: 24px;
      }
    }


  }

  .more-btn {
    width: 240px;
  }
}


.join {
  width: 100%;
  height: 200px;
  background-image: url("~@/assets/img/join/join.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  .title {
    background: linear-gradient(359.9999999898547deg, #CEC298 0%, #FFF2C6 52%, #D4C79D 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }

  .btn {
    width: 160px;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    border-radius: 59px 59px 59px 59px;
  }
}


</style>
